<template>
  <nav class="navbar shadow bg-white rounded justify-content-between">
    <div class="container">
      <b-navbar type="light">
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-link class="navbar-brand float-left" @click="clickedLogo">
            <img src="../assets/images/big-logo.png" class="logo" />
          </b-link>
          <div class="nav navbar-nav flex-row float-left">
            <li
              v-if="!loggedIn"
              @click="clickRecommend"
              class="nav-item btn-recommend"
            >
              Зөвлөмж
            </li>
            <li
              v-if="!loggedIn"
              @click="clickedLogin"
              to="/Login"
              class="nav-item btn-login"
            >
              Нэвтрэх
            </li>
            <li
              v-if="!loggedIn"
              @click="clickedRegister"
              class="nav-item btn-register"
            >
              Бүртгүүлэх
            </li>
            <Dropdownmenu v-if="loggedIn" />
          </div>
        </b-collapse>
      </b-navbar>
    </div>
  </nav>
</template>
<script>
import Dropdownmenu from "../components/Dropdownmenu.vue";
import user from "../mixins/user";
import { mapState } from "vuex";

export default {
  mixins: [user],
  data: function () {
    return {
      userName: "",
    };
  },
  components: {
    Dropdownmenu,
  },
  methods: {
    clickedLogo: function () {
      if (this.agreedToPrivacy === true) {
        if (this.$store.state.type === "student") {
          if (this.$route.name !== "LevelStage") {
            this.$router.push({
              name: "LevelStage",
            });
          }
        } else if (
          this.$store.state.type === "teacher" &&
          this.$route.name !== "TeacherPacket"
        ) {
          this.$router.push({
            name: "TeacherPacket",
          });
        }
      } else {
        if (this.$route.name !== "Home") {
          this.$router.push({
            name: "Home",
          });
        }
      }
    },
    clickRecommend: function () {
      if (this.$route.name !== "Recommend") {
        this.$router.push({
          name: "Recommend",
        });
      }
    },
    clickedLogin: function () {
      if (this.$route.name !== "Login") {
        this.$router.push({
          name: "Login",
        });
      }
    },
    clickedRegister: function () {
      if (this.$route.name !== "Registration") {
        this.$router.push({
          name: "Registration",
        });
      }
    },
  },
  computed: {
    ...mapState(["grantCount"])
  }
};
</script>

<style lang="postcss" scoped>
.justify-content-between {
  display: flex;
  justify-content: flex-end;
}
.navbar {
  width: 100%;
  font-family: "Roboto", sans-serif;
  color: #22b353;
}
.container {
  max-width: 1712px;
}
#nav a {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  text-decoration: none;
}

#nav a.router-link-exact-active {
  color: #ffffff;
}
#nav a:hover {
  color: #ffffff;
}
#nav-collapse {
  font-size: 1.37em;
  color: #dfe4ea;
  display: flex;
  justify-content: space-between;
}

.collapseChance:hover {
  color: #ffffff;
}
.collapseExplain:hover {
  color: #ffffff;
}

#nav a.router-link-exact-active {
  color: #ffffff;
}
#nav a:hover {
  color: #ffffff;
}
#login a {
  margin-top: "20px";
}
#nav-collapse {
  font-size: 1em;
  color: #dfe4ea;
  display: flex;
  justify-content: space-between;
  text-align: center;
}
.collapseChance:hover {
  color: #ffffff;
}
.collapseExplain:hover {
  color: #ffffff;
}

.nav-item.name {
  color: #000000;
  text-transform: uppercase;
  font-size: 1.5625em;
  display: flex;
  align-items: center;
  border: none;
  padding: 5px;
}

.nav {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.nav-item {
  border: 1px solid #52b700;
  border-radius: 20px;
  color: #878787;
  font-size: 1.25em;
  cursor: pointer;
}
.nav-item.btn-recommend {
  border: none;
  padding: 5px 10px;
}
.nav-item.btn-login {
  background-color: #22b353;
  color: #ffffff;
  margin-right: 5px;
  padding: 5px 10px;
}
.nav-item.btn-register {
  padding: 5px 10px;
}
.nav-item.btn-register:hover {
  background-color: #22b353;
  color: #ffffff;
}
.nav-item.btn-account {
  border: none;
}
.logo {
  width: auto;
  height: 50px;
}
@media screen and (max-width: 600px) {
  .nav-item.btn-register {
    margin-top: 10px;
  }
}
</style>
